import { notify } from "./notify";

export type TrackedFeature =
  | "sieveStack"
  | "bulkGrid"
  | "excelImport"
  | "templateDownload"
  | "languageSwitch"
  | "qrScan"
  | "equipmentSelect"
  | "reportExport"
  | "agsExport"
  | "auditLogOpened"
  | "reassign";

export function reportFeature(feature: TrackedFeature, detail?: string): void {
  notify("feature.used", detail === undefined ? { feature } : { feature, detail });
}
